import { PropsWithChildren } from "react";

import { ButtonCardStyle } from "./styles";

type ButtonCardProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "style">;

export const ButtonCard = (props: PropsWithChildren<ButtonCardProps>) => {
  return <ButtonCardStyle {...props} />;
};
